import React from 'react';
import { FDPaper, FDTitleText } from '@facet-wealth/design';
import useMetaLayoutContext from 'src/Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Richtext } from 'src/Packages/FacetDesign/Components/Richtext';

const ManagedAccountModelUpdateOpenCaseCard = () => {
  const { resource } = useMetaLayoutContext();
  const openCaseCard = resource.attr('openTIOCaseCard')?.resources().list()?.[0];

  return (
    <FDPaper color="attention" width={'100%'} padding={2}>
      <FDTitleText value={openCaseCard?.attr('title')} />
      <Richtext value={openCaseCard?.attr('description')} richtext />
    </FDPaper>
  );
};

export { ManagedAccountModelUpdateOpenCaseCard };
